// extracted by mini-css-extract-plugin
export default {"actions":"CollectionMiniButtons_actions__cyhwC"};